export default __webpack_public_path__ + "static/media/upload.fff8f549.svg";